import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit2",
  "use": "icon-edit2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-edit2\"><g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"currentColor\" stroke-width=\"1.5\" d=\"m11.253 1.99 2.121 2.12a.5.5 0 0 1 0 .708L5.243 12.95H2.414V10.12l8.132-8.131a.5.5 0 0 1 .707 0z\" /><path fill=\"currentColor\" d=\"m9.485 3.05 2.829 2.829-1.06 1.06-2.83-2.828z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol